import React from 'react';

export function NeedsLoadingProgress({ label = 'Cargando necesidades…', current, total }) {
  const determinate = Number.isFinite(total) && total > 0;
  const percent = determinate ? Math.min(100, Math.round(current / total * 100)) : undefined;
  return <div role="status" className="space-y-2 rounded border border-blue-200 bg-blue-50 p-3 text-sm text-blue-900">
    <div className="flex justify-between gap-3"><span>{label}</span>{determinate && <span className="tabular-nums">{current} / {total} · {percent}%</span>}</div>
    <progress aria-label={label} max={100} value={percent} className="block h-2 w-full accent-blue-600" />
  </div>;
}

// Batch new lists, but keep mounted rows when only their quantities or states change.
export function useProgressiveNeeds(items, batchSize = 15) {
  const listKey = JSON.stringify(items.map(item => item.key));
  const total = items.length;
  const [state, setState] = React.useState({ listKey: null, count: 0 });
  const count = state.listKey === listKey ? state.count : 0;
  React.useEffect(() => {
    if (count >= total) return;
    const timer = window.setTimeout(() => setState({ listKey, count: Math.min(total, count + batchSize) }), 16);
    return () => window.clearTimeout(timer);
  }, [listKey, total, count, batchSize]);
  return { visible: items.slice(0, count), current: count, total: items.length, loading: count < items.length };
}
